import { render, staticRenderFns } from "./bulkImport.vue?vue&type=template&id=61a3d14a"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"
import style0 from "./bulkImport.vue?vue&type=style&index=0&id=61a3d14a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a3d14a')) {
      api.createRecord('61a3d14a', component.options)
    } else {
      api.reload('61a3d14a', component.options)
    }
    module.hot.accept("./bulkImport.vue?vue&type=template&id=61a3d14a", function () {
      api.rerender('61a3d14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/handoverException/component/bulkImport.vue"
export default component.exports